export const VENUE_HOST_EVENT = 'venue_host';
export const VENUE_HOST_RESET = 'venue_host_reset';

export const WIDGET_OPEN = 'widget_open';
export const WIDGET_CLOSE = 'widget_close';
export const WIDGET_TOGGLE = 'widget_toggle';
export const WIDGET_NAVIGATE = 'widget_navigate';

export const GOTO_SECTION = 'goto_section';
